import { Fragment, useContext, useEffect } from "react";
import { CategoryContainer } from "./categoryContainer";
import { NewProductAlgolia } from "./newProductAlgolia";
import { FeaturedProducts } from "./featuredProducts";
import { EbookPosterContainer } from "./ebookPosterContainer";
import { ClearanceProductAlgolia } from "./clearanceProductAlgolia";
import { BrandListContainer } from "./brandListContainer";
import { PreviousOrderPopup } from "../../Layout/Common/PopUp/previousOrderPopUp";
import { SpecialProductAlgolia } from "./specialProductContainer";
import { PartyWelcomePopup } from "./PartyWelcomePopup";
import { PartyPopperBlast } from "./PartyPopperBlast";
import { NewProductCategoryGrid } from "../../Layout/Common/newproductCategoryGrid";
import { isValidArray } from "../../Layout/Common/common";
import { GlobalContext } from "../../Context/GlobalContext";
import { Link } from "react-router-dom";
import { PAGES } from "../../routeConfig";
import { NewProductCategoryContainer } from "./newCategoryGrid";
import { TopBannerPanel } from "./topBannerList";
import { WelcomePopup } from "../../Layout/Common/PopUp/welcomePopUp";
export const HomePageMainContainer = () => {
  return (
    <Fragment>
      {/* <PartyWelcomePopup /> */}
      <WelcomePopup />
      <TopBannerPanel />
      <NewProductCategoryContainer />
      <NewProductAlgolia />
      <FeaturedProducts />
      <SpecialProductAlgolia />
      <EbookPosterContainer />
      <ClearanceProductAlgolia />
      {/* <BrandListContainer /> */}
    </Fragment>
  );
};
